import { render, staticRenderFns } from "./LeastSquares.vue?vue&type=template&id=990270c4&scoped=true&"
import script from "./LeastSquares.vue?vue&type=script&lang=js&"
export * from "./LeastSquares.vue?vue&type=script&lang=js&"
import style0 from "./LeastSquares.vue?vue&type=style&index=0&id=990270c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990270c4",
  null
  
)

export default component.exports